export const DTOOLS_SI_QUOTE_ACTIONS_REFETCH_INTERVAL_MS = 30_000
export const DTOOLS_SI_IMPORT_POST_TIMEOUT_MS = 4 * 60 * 1_000
export const DTOOLS_SI_IMPORT_RECOVERY_WINDOW_MS = 8 * 60 * 1_000
const QUOTE_DTOOLS_STATE_PENDING = 309890001

export function buildDtoolsSiProjectDetailParams({
  projectNumber,
  throughCoNumber,
  replaceExisting,
}: {
  projectNumber: string
  throughCoNumber: number | null
  replaceExisting: boolean
}) {
  const params = new URLSearchParams({ project_number: projectNumber })
  if (throughCoNumber != null) params.set('through_co_number', String(throughCoNumber))
  if (replaceExisting) params.set('replace_existing', 'true')
  return params
}

export function getDtoolsSiQuoteActionsRefetchInterval(data: {
  dtools_si_project?: { last_state?: number | null } | null
} | undefined) {
  return data?.dtools_si_project?.last_state === QUOTE_DTOOLS_STATE_PENDING
    ? DTOOLS_SI_QUOTE_ACTIONS_REFETCH_INTERVAL_MS
    : false
}

export type DtoolsSiImportStatus =
  | 'not_found'
  | 'pending'
  | 'imported'
  | 'imported_ack_pending'
  | 'failed'
  | 'unknown'

export function getDtoolsSiImportRecoveryAction(
  status: DtoolsSiImportStatus
): 'continue' | 'succeed' | 'succeed_with_warning' | 'fail' {
  if (status === 'imported') return 'succeed'
  if (status === 'imported_ack_pending') return 'succeed_with_warning'
  if (status === 'failed') return 'fail'
  return 'continue'
}

function timestampMs(value: string | null | undefined) {
  if (!value) return null
  const normalized = /(?:Z|[+-]\d{2}:\d{2})$/i.test(value) ? value : `${value}Z`
  const parsed = Date.parse(normalized)
  return Number.isFinite(parsed) ? parsed : null
}

export function hasNewerDtoolsSiBaseRevision(
  sourcePublishedOn: string | null | undefined,
  importedPublishedOn: string | null | undefined,
  legacyConfirmedOn: string | null | undefined
) {
  const source = timestampMs(sourcePublishedOn)
  const imported = timestampMs(importedPublishedOn) ?? timestampMs(legacyConfirmedOn)
  return source != null && imported != null && source > imported
}
